/**
 * Every supplier with something going on in the portal, at a glance.
 *
 * The rest of this screen answers "how is this one supplier set up?", which
 * means opening each of them in turn to find the two that are actually live.
 * This is the same information for all of them at once, and a row selects its
 * supplier rather than making the operator find it again in the picker.
 */
define('portalOverviewView',[
  'module',
  'marionette',
  'underscore',
  'app',
  'jquery',
  'template!portalOverviewTpl',
  'entities/suppliers/portal_users'
], function (
  Module,
  Marionette,
  _,
  App,
  $,
  overviewTpl
) {
  'use strict';

  Module.exports = Marionette.ItemView.extend({
    template: overviewTpl,
    className: 'portal-overview-view',

    ui: {
      row: '.js-row',
      toggleAll: '.js-toggle-all'
    },

    events: {
      'click @ui.row': 'onRow',
      'click @ui.toggleAll': 'onToggleAll'
    },

    initialize: function (options) {
      this.rows = options.rows || [];
      // Off by default: the question this answers is "who is live", and a list
      // of every shared account would bury the handful that are.
      this.all = options.all === true;
      this.failed = options.failed === true;
    },

    serializeData: function () {
      return {
        rows: _.map(this.rows, function (row) {
          return {
            supplierSecId: row.supplierSecId,
            code: row.supplierCode,
            name: row.supplierName,
            usePortal: row.usePortal === true,
            // Absent means granted, same as the server's default.
            orders: row.portalOrders !== false,
            products: row.portalProducts !== false,
            team: row.portalTeam !== false,
            allowLabels: row.allowLabels === true,
            accounts: row.accounts || 0,
            activeAccounts: row.activeAccounts || 0,
            // Worth flagging: logins exist but no order will ever arrive.
            signedInButUnrouted: row.usePortal !== true && (row.accounts || 0) > 0
          };
        }),
        all: this.all,
        failed: this.failed,
        empty: this.rows.length === 0
      };
    },

    onRow: function (event) {
      this.trigger('selected', $(event.currentTarget).data('secid'));
    },

    onToggleAll: function () {
      this.trigger('toggle:all', !this.all);
    }
  });
});

